import { render, staticRenderFns } from "./FormChooseSingleOptionList.vue?vue&type=template&id=f1ffb640&scoped=true&"
import script from "./form-choose-single-option-list.js?vue&type=script&lang=js&"
export * from "./form-choose-single-option-list.js?vue&type=script&lang=js&"
import style0 from "./form-choose-single-option-list.scss?vue&type=style&index=0&id=f1ffb640&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1ffb640",
  null
  
)

export default component.exports